import React, { useState } from 'react';
import { Collapse } from 'react-bootstrap';
import {
  ChevronDown,
  ChevronUp,
  QuestionCircleFill,
} from 'react-bootstrap-icons';

interface InfoToggleProps {
  title: string;
  children: React.ReactNode;
}

/**
 * Trigger renderuje się inline (fragment), content rozwija się na pełną szerokość poniżej.
 * Wymaga flex-wrap na kontenerze rodzica.
 */
export const InfoToggle: React.FC<InfoToggleProps> = ({ title, children }) => {
  const [open, setOpen] = useState(false);

  return (
    <>
      <button
        className="btn btn-link btn-sm text-info text-decoration-none p-0 d-inline-flex align-items-center gap-1"
        onClick={() => setOpen(o => !o)}
        aria-expanded={open}
      >
        <QuestionCircleFill size={13} />
        {title}
        {open ? <ChevronUp size={11} /> : <ChevronDown size={11} />}
      </button>
      <div style={{ flexBasis: '100%', width: '100%' }}>
        <Collapse in={open}>
          <div>
            <div className="mt-2 p-3 small border border-info border-opacity-25 rounded bg-info bg-opacity-10">
              {children}
            </div>
          </div>
        </Collapse>
      </div>
    </>
  );
};
